import { isFunction } from "lodash";
import Button from "./Button";

const ActionButtons = ({
  onNext,
  onBack,
  buttonText = "Suivant",
  disabled = false,
  buttonWidth = 366,
  icon,
  loading,
}) => {
  return (
    <div className="mobilityMutual__actions">
      {isFunction(onBack) && (
        <Button
          type="primary-outlined"
          width={120}
          alignment="center"
          onClick={onBack}
        >
          Retour
        </Button>
      )}
      {isFunction(onNext) && (
        <Button
          type="primary"
          width={buttonWidth}
          alignment="center"
          disabled={disabled}
          onClick={onNext}
          loading={loading}
          className={icon ? "has-icon" : ""}
          icon={icon}
        >
          {buttonText}
        </Button>
      )}
    </div>
  );
};

export default ActionButtons;
